import React from "react";
import styled from "styled-components";

export default function Beneficios(props) {
  const cardsData = [
    {
      id: "6721a138-cac4-42e8-8d52-b5e80163bba1",
      title: "Ingresso.com",
      image: "https://imguol.com.br/p/pp/uol-play/nova-pv/beneficios/1.png",
      bgColor: "#6C04BA",
      border: "2px solid #AF45FF",
      boldText: "Voucher de R$40 todo mês",
      text: " para usar em cinema na ingresso.com",
      link: {
        url: "https://play.uol.com.br/receba40",
        label: "Consulte o regulamento",
      },
    },
    {
      id: "38cd4fd4-44c4-4dc8-93df-c81fcb9e4b56",
      title: "Clube UOL",
      image: "https://imguol.com.br/p/pp/uol-play/nova-pv/beneficios/2.png",
      bgColor: "#CE4700",
      border: "2px solid #FF8000",
      boldText: "Descontos de até 50%",
      text: " em grandes marcas",
    },
    {
      id: "c04d068b-9326-44ba-a30f-7c7ab894f9a4",
      title: "Skeelo",
      image: "https://imguol.com.br/p/pp/uol-play/nova-pv/beneficios/3.png",
      bgColor: "#204B41",
      border: "2px solid #10B1A8",
      boldText: "Milhares de livros digitais",
      text: " para você ler pelo celular. Para ganhar um e-book todo mês, baixe o app.",
    },
  ];

  return (
    <Section>
      <Title>E tem mais! Assinando o UOL Play você ainda leva:</Title>
      <CardContainer>
        {cardsData.map(
          ({ id, title, image, bgColor, text, border, boldText, link }) => (
            <Card key={id} $bgColor={bgColor} $border={border}>
              <CardImage src={image} alt={title} />
              <CardText>
                <BoldText>{boldText}</BoldText>
                {text}
                {link && (
                  <CardLink
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.label}
                  </CardLink>
                )}
              </CardText>
            </Card>
          )
        )}
      </CardContainer>
    </Section>
  );
}

const Section = styled.div`
  padding: 80px;

  @media (max-width: 768px) {
    margin: 40px 0;
    padding: 0;
  }
`;

const Title = styled.h4`
  font-size: 32px;
  color: white;
  text-align: center;
  padding-bottom: 70px;

  @media (max-width: 768px) {
    font-size: 28px;
    padding: 20px;
    padding-bottom: 40px;
  }
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 70px;

  @media (max-width: 1310px) {
    flex-direction: column;
    width: 380px;
    gap: 40px;
    margin: 0 auto;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  align-items: center;
  width: 380px;
  height: 160px;
  border-radius: 4px;
  background-color: ${({ $bgColor }) => $bgColor || "#fff"};
  border: ${({ $border }) => $border || "1px solid #fff"};
`;

const CardImage = styled.img`
  height: 160px;
`;

const CardText = styled.p`
  font-size: 16px;
  color: white;
  padding: 0 10px;
`;

const BoldText = styled.span`
  font-weight: bold;
`;

const CardLink = styled.a`
  display: block;
  margin-top: 10px;
  color: #c7c7c7;
  text-decoration: underline;
  font-size: 12px;

  &:hover {
    color: #c7c7c7;
    text-decoration: none;
  }
`;
